export default {
    "festiware": {
        'repeater': {
            'is_owner_person': 'Ist Ansprechperson',
            'is_owner_person_hint': '<div class="uk-alert uk-alert-primary uk-margin-remove-bottom">Hinweis: Die nötigen Angaben zur Ansprechperson werden hier verwendet. Falls diese noch nicht eingegeben wurden, werden sie in einem nächsten Schritt erfragt.</div>',
            'add': 'Person hinzufügen',
            'change_owner_person': '<div class="uk-flex"><div class="uk-width-small"><i uk-icon="icon:warning; ratio:2"></i></div><div>Achtung: Eine Änderung der Ansprechperson hat zur Folge, dass dieses Formular nach dem Speichern nicht mehr aufgerufen werden kann!</div>',
            'bulk_upload': {
                'toggle': 'Personen aus CSV-/Excel-Datei importieren',
                'button': 'Liste hochladen',
                'template': 'Vorlage herunterladen',
                'template_filename': 'import-vorlage',
                'hint': 'Mehrere Personen aus einer CSV- oder Excel-Datei übernehmen, statt sie einzeln einzugeben.',
                'phone_hint': 'Telefonnummern mit führender 0 (z. B. 0160 1234567) oder mit Ländervorwahl (z. B. +49 160 1234567) angeben — Leerzeichen sind erlaubt. Damit Excel das + oder die führende 0 nicht entfernt, die Telefonspalte als Text formatieren oder die Datei als CSV speichern.',
                'imported': ':count Zeile(n) übernommen. Bitte die Angaben prüfen und das Formular absenden.',
                'unmatched': 'Nicht zugeordnete Spalten: :columns.',
                'unmatched_values': 'Spalte „:field": Die Werte :values passen zu keiner Auswahlmöglichkeit und bleiben leer. Erlaubt sind: :options.',
                'limit': ':skipped Zeile(n) wurden nicht hinzugefügt — die maximale Anzahl (:max) ist erreicht.',
                'limit_full': 'Die maximale Anzahl (:max) ist bereits erreicht. Es wurden keine Zeilen hinzugefügt.',
                'empty': 'Die Datei enthält keine verwertbaren Zeilen.',
                'error': 'Die Datei konnte nicht gelesen werden. Bitte eine CSV- oder Excel-Datei verwenden.',
                'progress_reading': 'Datei wird gelesen …',
                'progress_importing': 'Importiere Personen … (:done von :total)'
            }
        },
        'use_stored_data': 'Im Formular wurden bereits Eingaben vorgenommen. Soll fortgefahren werden?',
        'yes': 'Ja',
        'no': 'Nein',
        'update_success_default': 'Die Angaben wurden erfolgreich gespeichert.',
        'selfie': {
            'select': 'Bild wählen',
            'camera': 'Mit Kamera aufnehmen',
            'camera_starting': 'Kamera wird gestartet …',
            'camera_label': 'Kamera',
            'capture': 'Foto aufnehmen',
            'cancel': 'Abbrechen',
            'confirm': 'Ausschnitt übernehmen',
            'discard': 'Verwerfen',
            'zoom': 'Zoom',
            'reset': 'Zurücksetzen',
            'ratio': 'Seitenverhältnis:',
            'hint': 'Bild verschieben (ziehen) und zoomen — dieser Ausschnitt wird gespeichert.',
            'camera_not_ready': 'Die Kamera liefert noch kein Bild. Bitte kurz warten und erneut versuchen.',
            'camera_denied': 'Der Kamerazugriff wurde abgelehnt. Bitte im Browser für diese Seite erlauben.',
            'camera_missing': 'Es wurde keine Kamera gefunden.',
            'camera_busy': 'Die Kamera ist belegt — bitte andere Programme schließen, die sie nutzen.',
            'camera_failed': 'Die Kamera konnte nicht gestartet werden.',
            'crop_failed': 'Der Bildausschnitt konnte nicht erzeugt werden.',
        },
        'calendar': {
            'text': 'Den immer aktuellen Stand der Termine zum Abonnieren in einer Kalender-App gibt es unter folgendem Link:',
            'link': 'Kalender-Abonnement URL',
        },
        'errors': {
            'owner_person_not_defined' :'Es wurde keine Ansprechperson angegeben. Bitte passe die Angabe bei den Personen-Feldern entsprechend an.',
            'update_request_target_missing': 'Die zu bearbeitende Gruppe konnte nicht eindeutig zugeordnet werden. Bitte das Formular über die jeweilige Gruppe im Portal erneut öffnen oder den Veranstalter kontaktieren.',
            'not_valid_for_group': 'Für diese Gruppe besteht keine Bearbeitungsberechtigung. Bitte das Formular über die zugehörige Gruppe im Portal öffnen oder den Veranstalter kontaktieren.',
            'person_deactivated': 'Der Zugang zum Portal wurde deaktiviert. Die Angaben können nicht mehr geändert werden. Bitte den Veranstalter kontaktieren, falls das ein Irrtum ist.',
            'events_maximum_selection_exceeded': 'Es wurden mehr Termine ausgewählt als zulässig. Bitte die Auswahl reduzieren und erneut speichern.',
            'tab_hint': 'Es gibt noch fehlende Angaben bei',
            'tab_hint_buttons': {'ok': 'Verstanden'},
            'generic_error': 'Ein Fehler ist aufgetreten. Bitte versuche es später erneut.',
        },
        'tabs': {
            'scrollLeft': 'Tabs nach links scrollen',
            'scrollRight': 'Tabs nach rechts scrollen',
            'offscreenErrors': 'Fehler',
            'errorBadge': 'Fehler',
            'save': 'Speichern',
            'saving': 'Speichern…',
        },
        'steps': {
            'scrollLeft': 'Schritte nach links scrollen',
            'scrollRight': 'Schritte nach rechts scrollen',
            'offscreenErrors': 'Fehler',
            'errorBadge': 'Fehler',
        },
        'no_visible_fields': 'Aktuell sind keine Felder zur Bearbeitung verfügbar.',
        'uploading_files': 'Upload von :count Datei(en). Bitte warten…',
        'upload_failed': 'Der Upload ist fehlgeschlagen. Bitte versuche es erneut.',
        'events': {
            'no_events': 'Keine Termine verfügbar',
            'not_available': 'Nicht mehr verfügbar',
            'free_slots': ':count freie Plätze',
            'only_one_place': 'Ereignisse können nur an einem Ort ausgewählt werden, nicht an mehreren.',
            'maximum_reached': 'Die maximale Anzahl an Ereignissen wurde bereits ausgewählt.',
            'minimum_not_met': 'Bitte wähle mindestens :min Termine aus, bevor du speicherst.',
            'selection_hint_exact': 'Wähle genau :min Termine aus (:selected ausgewählt)',
            'selection_hint_min': 'Wähle mindestens :min Termine aus (:selected ausgewählt)',
            'selection_hint_max': 'Wähle höchstens :max Termine aus (:selected ausgewählt)',
            'selection_hint_range': 'Wähle zwischen :min und :max Termine aus (:selected ausgewählt)',
            'date': 'Datum',
            'datetime': 'Datum & Uhrzeit',
            'duration': 'Dauer',
            'save': 'Speichern'
        }
    },
    "validation": {
        "phoneNumber": "Dies ist kein gültiges Telefonnummer-Format.",
        "dateText": "Bitte ein vollständiges Datum im Format TT.MM.JJJJ eingeben.",
    },
    "vueform": {
        "elements": {
            "list": {
                "add": "+ Hinzufügen",
            },
            "file": {
                "defaultName": "Datei",
                "dndTitle": "Datei hochladen",
                "dndDescription": "Datei hier hineinziehen oder zum Hochladen hier klicken",
                "removeConfirm": "Durch das Entfernen der Datei wird diese endgültig gelöscht. Bist du sicher, dass du fortfahren möchtest?",
                "select": "Datei auswählen",
                "upload": "Hochladen"
            },
            "multifile": {
                "uploadButton": "Dateien hochladen",
                "dndTitle": "Dateien hochladen",
                "dndDescription": "Dateien hier hineinziehen oder zum Hochladen hier klicken"
            },
        },
        "phone": {
            "ariaLabel": "Land auswählen",
        },
        "steps": {
            "finish": "Beenden",
            "next": "Weiter",
            "previous": "Zurück"
        },
        "multiselect": {
            "multipleLabelOne": "1 Option ausgewählt",
            "multipleLabelMore": ":options Optionen ausgewählt",
            "noResults": "Keine Optionen gefunden",
            "noOptions": "Liste ist leer."
        },
    }
}
